import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import BackupRetentionSimulator from './BackupRetentionSimulator';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BackupRetentionSimulator/>
    </React.StrictMode>
);
